<template>
  <div class="spotlight-inner-wrapper">
    <Hero
      :title="$t(`message.spotlight.sxm['${introKey}'].title`)"
      :text="$t(`message.spotlight.sxm['${introKey}'].text`, { duration: hasSxmProgram ? sxmPayload.duration : null })"
    ></Hero>
    <router-link :to="{ name: `spotlight-report-request-${baseRoute}` }">
      {{ $t(`message.spotlight.sxm['${introKey}'].linkText`) }}
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none">
          <g fill="#1171bb">
            <path
              d="M5.6 2.8L5.1 3.3C5 3.4 5 3.6 5.1 3.7L9.4 8 5.1 12.3C5 12.4 5 12.6 5.1 12.7L5.6 13.2C5.7 13.3 5.8 13.3 6 13.2L10.9 8.2C11 8.1 11 7.9 10.9 7.8L6 2.8C5.8 2.7 5.7 2.7 5.6 2.8Z"
            />
          </g>
        </g>
      </svg>
    </router-link>
    <SXMVideo class="video-container" :video-id="videoId" product="sxm"></SXMVideo>
    <CTA />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Hero from '@/modules/spotlight/components/Hero.vue';
import SXMVideo from '@/modules/spotlight/components/SpotlightVideoPlayer.vue';
import CTA from '@/components/ProductCTAs.vue';

export default {
  name: 'Intro',
  components: {
    Hero,
    SXMVideo,
    CTA,
  },
  computed: {
    ...mapGetters('spotlight', ['hasSxmProgram', 'sxmPayload']),
    introKey() {
      return this.hasSxmProgram ? 'introProgram' : 'introEquipped';
    },
    videoId() {
      const isEnglish = this.$i18n.locale.includes('en');
      return isEnglish ? 'w3rIdBa34Wc' : 'PcCwxqH1-Bs';
    },
  },
};
</script>

<style scoped lang="scss">
a {
  font-weight: 500;
  display: block;
  margin-bottom: 24px;
}
.video-container {
  margin-bottom: 32px;
}
</style>
